import { useMemo } from 'react'

export function useMemoValue<T>(value: T): T {
  /* oxlint-disable react-hooks/exhaustive-deps */
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- deep equality
  return useMemo(() => value, [JSON.stringify(value)])
}
